var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Tooltip as ReactTippy } from 'react-tippy';
import { propBool, propChildren, propStr, propNumber, propShape, propFunc, } from '../../../helpers/custom-prop-types';
const Tooltip = (props) => {
    const { children, tooltipRef } = props, tooltipProps = __rest(props, ["children", "tooltipRef"]);
    return (_jsx(ReactTippy, Object.assign({ ref: tooltipRef }, tooltipProps, { children: children })));
};
Tooltip.propTypes = {
    animation: propStr(),
    arrow: propBool(),
    children: propChildren().isRequired,
    className: propStr(),
    disabled: propBool(),
    distance: propNumber(),
    duration: propNumber(),
    html: propChildren().isRequired,
    interactive: propBool(),
    onRequestClose: propFunc(),
    open: propBool(),
    popperOptions: propShape(),
    position: propStr(),
    style: propShape(),
    theme: propStr(),
    tooltipRef: propShape(),
    trigger: propStr(),
    zIndex: propNumber(),
};
Tooltip.defaultProps = {
    animation: 'scale',
    arrow: true,
    className: undefined,
    disabled: undefined,
    distance: undefined,
    duration: 100,
    interactive: false,
    onRequestClose: undefined,
    open: undefined,
    popperOptions: undefined,
    position: undefined,
    style: undefined,
    theme: undefined,
    tooltipRef: undefined,
    trigger: undefined,
    zIndex: 999,
};
export default Tooltip;
